/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { StaticPageNestedCalculator } from './StaticPageNestedCalculator'
import {
  StaticPageNestedCalculatorFromJSON,
  StaticPageNestedCalculatorFromJSONTyped,
  StaticPageNestedCalculatorToJSON,
} from './StaticPageNestedCalculator'

/**
 *
 * @export
 * @interface StaticPageDetailAdmin
 */
export interface StaticPageDetailAdmin {
  /**
   *
   * @type {number}
   * @memberof StaticPageDetailAdmin
   */
  readonly id: number
  /**
   *
   * @type {string}
   * @memberof StaticPageDetailAdmin
   */
  slug: string
  /**
   *
   * @type {string}
   * @memberof StaticPageDetailAdmin
   */
  name: string
  /**
   *
   * @type {string}
   * @memberof StaticPageDetailAdmin
   */
  header?: string | null
  /**
   *
   * @type {string}
   * @memberof StaticPageDetailAdmin
   */
  titleTag?: string | null
  /**
   *
   * @type {string}
   * @memberof StaticPageDetailAdmin
   */
  descriptionTag?: string | null
  /**
   *
   * @type {string}
   * @memberof StaticPageDetailAdmin
   */
  canonicalUrl?: string | null
  /**
   *
   * @type {number}
   * @memberof StaticPageDetailAdmin
   */
  serviceId?: number | null
  /**
   *
   * @type {StaticPageNestedCalculator}
   * @memberof StaticPageDetailAdmin
   */
  readonly calculator: StaticPageNestedCalculator | null
}

/**
 * Check if a given object implements the StaticPageDetailAdmin interface.
 */
export function instanceOfStaticPageDetailAdmin(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'id' in value
  isInstance = isInstance && 'slug' in value
  isInstance = isInstance && 'name' in value
  isInstance = isInstance && 'calculator' in value

  return isInstance
}

export function StaticPageDetailAdminFromJSON(json: any): StaticPageDetailAdmin {
  return StaticPageDetailAdminFromJSONTyped(json, false)
}

export function StaticPageDetailAdminFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): StaticPageDetailAdmin {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    slug: json['slug'],
    name: json['name'],
    header: !exists(json, 'header') ? undefined : json['header'],
    titleTag: !exists(json, 'titleTag') ? undefined : json['titleTag'],
    descriptionTag: !exists(json, 'descriptionTag') ? undefined : json['descriptionTag'],
    canonicalUrl: !exists(json, 'canonicalUrl') ? undefined : json['canonicalUrl'],
    serviceId: !exists(json, 'serviceId') ? undefined : json['serviceId'],
    calculator: StaticPageNestedCalculatorFromJSON(json['calculator']),
  }
}

export function StaticPageDetailAdminToJSON(value?: StaticPageDetailAdmin | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    slug: value.slug,
    name: value.name,
    header: value.header,
    titleTag: value.titleTag,
    descriptionTag: value.descriptionTag,
    canonicalUrl: value.canonicalUrl,
    serviceId: value.serviceId,
  }
}
